import Vue from 'vue';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import { getElementUILanguage } from '@/i18n';

Vue.use(Element, { locale: getElementUILanguage() });
